jQuery(function($) {

  /* Newsletter */
  $('.newsletter-overlay').on('click', function() {
    close_newsletter();
  })

  $(".newsletter-close").on("click", function (e) {
    e.preventDefault();
    close_newsletter();
  })

  $(".newsletter-btn").on("click", function (e) {
    e.preventDefault();
    open_newsletter();
  })

  function open_newsletter() {
    $(".newsletter-drawer").addClass('open');
    $('body').addClass('overlay-open');
  }

  function close_newsletter() {
    $(".newsletter-drawer").removeClass('open');
    $('body').removeClass('overlay-open');
  }

  // TOC toggle
  $('.toc-sidebar .sidebar-header').on('click', function() {
    const content = $('.toc-sidebar .sidebar-content')
    const height = content.prop('scrollHeight')
    const actualHeight = content.height()
    const newHeight = (height === actualHeight) ? 0 : height
    content.css('max-height', `${newHeight}px`)

  })
})

// header scroll animation
var scroll_pos = 0;
var last_scroll_pos = 0;
var ticking = false;
var down_scroll_pos_trigger = 130;
var up_scroll_pos_trigger = 75;

const fade_observer = new IntersectionObserver((entries, observer) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('in-view')
      observer.unobserve(entry.target)
    }
  })
}, {
  threshold: .1
})

const fade_in_content = document.querySelectorAll('.kp-fade-in-animation');
fade_in_content.forEach(block => {
  fade_observer.observe(block)
})


const bodyEl = document.querySelector('body')
const downThreshold = 140
function animateMenu(scroll_pos, direction) {
  if (direction === 'down' && scroll_pos >= downThreshold && !bodyEl.classList.contains('hide-menu')) {
    bodyEl.classList.add('hide-menu')
  }
  if (direction === 'up' && bodyEl.classList.contains('hide-menu')) {
    bodyEl.classList.remove('hide-menu')
  }
}

window.addEventListener( 'scroll', handleScroll, {passive: true} );

function handleScroll() {
  scroll_pos = window.scrollY;
  if (!ticking) {
    window.requestAnimationFrame(function() {
      let direction = getDirection(scroll_pos, last_scroll_pos);

      animateMenu(scroll_pos, direction)

      ticking = false;
      last_scroll_pos = scroll_pos;
    });

    ticking = true;
  }
}

function getDirection(scroll_pos, last_scroll_pos) {
  if ( scroll_pos > last_scroll_pos ) {
    return 'down';
  } else if ( scroll_pos < last_scroll_pos ) {
    return 'up';
  }
}

// prevent the mobile menu from staying open when pressing the back button
window.addEventListener('pagehide', function () {
  jQuery(document.body).removeClass('menu-open')
  jQuery('.mobile-menu > ul').removeClass('menu-open');
})